import { render } from "./Hero.vue?vue&type=template&id=1e5010ad&scoped=true&ts=true"
import script from "./Hero.vue?vue&type=script&lang=ts"
export * from "./Hero.vue?vue&type=script&lang=ts"

import "./Hero.vue?vue&type=style&index=0&id=1e5010ad&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e5010ad"]])

export default __exports__